import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TitleService } from '@app/shared/services/title/title.service';
import { ArticlePage } from '../../models/support-documentation';
import { OverlaySimulatorService } from '../../services/overlay-simulator.service';
import { SupportDocumentationService } from '../../services/support-documentation.service';

@Component({
  standalone: false,
  selector: 'sbnb-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss'],
})
export class ArticleComponent implements OnInit, AfterViewInit, OnDestroy {
  loading: boolean = true;
  feedbackLoading: boolean = false;
  feedbackState: string = 'question';
  slug: string;
  article: ArticlePage;

  constructor(
    public overlaySimulatorService: OverlaySimulatorService,
    private supportDocumentationService: SupportDocumentationService,
    private route: ActivatedRoute,
    private router: Router,
    private titleService: TitleService,
    private el: ElementRef
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(({ slug }) => {
      this.loading = true;
      this.slug = slug;

      if (!this.slug) {
        this.router.navigate(['/support-documentation']);
      }

      this.supportDocumentationService.getArticlePage(this.slug).subscribe(
        (article: ArticlePage) => {
          this.article = article;
          this.loading = false;

          this.titleService.manuallySet(this.article.title);
        },
        (err) => {
          this.router.navigate(['/support-documentation']);
        }
      );
    });
  }

  ngAfterViewInit() {
    this.el.nativeElement.addEventListener('click', this.handleAnchorClick);
  }

  ngOnDestroy() {
    this.el.nativeElement.removeEventListener('click', this.handleAnchorClick);
  }

  handleAnchorClick = (event: MouseEvent) => {
    const target = event.target as HTMLAnchorElement;

    if (target.tagName.toLowerCase() === 'a' && target.hash) {
      event.preventDefault();
      const elementToScroll = document.querySelector(target.hash);
      if (elementToScroll) {
        elementToScroll.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  @HostListener('window:keydown.escape')
  close() {
    this.overlaySimulatorService.close();
  }

  sendFeedback(feedback: 'positive' | 'negative') {
    this.feedbackLoading = true;
    this.supportDocumentationService.sendFeedback(this.slug, feedback).subscribe(() => {
      this.feedbackLoading = false;
      this.feedbackState = feedback;
    });
  }
}
